import type { SidebarMenuItemsType, SidebarMenuGroupItems } from './SidebarMenus';

/**
 * 检查菜单项是否为分组类型
 */
export const isSidebarGroupItems = (items: SidebarMenuItemsType): items is SidebarMenuGroupItems =>
    Array.isArray(items) && items.every(item => typeof item === 'object' && 'items' in item && Array.isArray(item.items)); 